"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiErrorTranslationKeys = void 0;
var atoz_shiftapp_metrics_1 = require("@amzn/atoz-shiftapp-metrics");
var constants_1 = require("../constants");
function getApiErrorTranslationKeys(error, operationType) {
    var genericErrorTranslationKeys = {
        title: 'shift_management_errors_genericError_title',
        body: 'shift_management_errors_genericError_body'
    };
    if (!error) {
        return [genericErrorTranslationKeys];
    }
    if (error.networkError) {
        return [
            {
                title: 'shift_management_errors_networkError_title',
                body: 'shift_management_errors_networkError_body'
            }
        ];
    }
    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
        var errorTranslationKeys = error.graphQLErrors.map(function (err) {
            try {
                var reason = JSON.parse(err.message).reason;
                // Reason is defined and in our list of mapped reasons
                if (reason && Object.keys(constants_1.ApiErrorMappings).includes(reason)) {
                    var errorKey = operationType
                        ? "".concat(constants_1.ApiErrorMappings[reason], "_").concat(operationType)
                        : constants_1.ApiErrorMappings[reason];
                    return {
                        title: "shift_management_errors_".concat(errorKey, "_title"),
                        body: "shift_management_errors_".concat(errorKey, "_body")
                    };
                }
                // Logging as a warn to prevent duplicate logs, as GQL errors are already logged separately
                atoz_shiftapp_metrics_1.logger.emitWarn('Failed to map error to translation', {
                    error: err
                });
                // If reason is undefined, return generic error
                return genericErrorTranslationKeys;
            }
            catch (err) {
                return genericErrorTranslationKeys;
            }
        });
        return errorTranslationKeys;
    }
    // Generic error if graphQLErrors and networkError are undefined
    return [genericErrorTranslationKeys];
}
exports.getApiErrorTranslationKeys = getApiErrorTranslationKeys;
